var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQrCode(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "-2 -2 24.00 24.00",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  }, /*#__PURE__*/React.createElement("rect", {
    x: -2,
    y: -2,
    width: 24,
    height: 24,
    rx: 0,
    fill: "#ffffff",
    strokeWidth: 0
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 4.5,
    width: 5,
    height: 5,
    rx: 0.5
  })), /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 4.5,
    width: 5,
    height: 5,
    rx: 0.5,
    stroke: "#0f3b46",
    strokeWidth: 3,
    strokeLinecap: "square",
    strokeLinejoin: "round",
    mask: "url(#path-1-inside-1)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10.5,
    y: 4.5,
    width: 5,
    height: 5,
    rx: 0.5
  })), /*#__PURE__*/React.createElement("rect", {
    x: 10.5,
    y: 4.5,
    width: 5,
    height: 5,
    rx: 0.5,
    stroke: "#0f3b46",
    strokeWidth: 3,
    strokeLinecap: "square",
    strokeLinejoin: "round",
    mask: "url(#path-2-inside-2)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-3",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 10.5,
    width: 5,
    height: 5,
    rx: 0.5
  })), /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 10.5,
    width: 5,
    height: 5,
    rx: 0.5,
    stroke: "#0f3b46",
    strokeWidth: 3,
    strokeLinecap: "square",
    strokeLinejoin: "round",
    mask: "url(#path-3-inside-3)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10.5,
    y: 10.5,
    width: 5,
    height: 5,
    rx: 0.5
  })), /*#__PURE__*/React.createElement("rect", {
    x: 10.5,
    y: 10.5,
    width: 5,
    height: 5,
    rx: 0.5,
    fill: "#0f3b46",
    stroke: "#0f3b46",
    strokeWidth: 3,
    strokeLinecap: "square",
    strokeLinejoin: "round",
    mask: "url(#path-4-inside-4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 3H6.5",
    stroke: "#0f3b46",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 3V6.5",
    stroke: "#0f3b46",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 17L3 13.5",
    stroke: "#0f3b46",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 17H6.5",
    stroke: "#0f3b46",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 17H13.5",
    stroke: "#0f3b46",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 17V13.5",
    stroke: "#0f3b46",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 3V6.5",
    stroke: "#0f3b46",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 3L13.5 3",
    stroke: "#0f3b46",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrCode);
export default __webpack_public_path__ + "static/media/qrCode.e63c68bcac9f23ca869f62a20599ded5.svg";
export { ForwardRef as ReactComponent };